import React, { useEffect, useState } from "react";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ProfileCompletionExperienceDiv from "./ProfileCompletionExperienceDiv";
import ProfileCompletionExperienceModal from "./ProfileCompletionExperienceModal";
import { isEmpty } from "lodash";


function ProfileCompletionCandidateExperience({data,getUpdatedData,asterikSign, errorSec, error}) {  
  console.log({profileExp:data})
const [experienceData,setExperienceData]=useState(data) 
const [editData,setEditData]=useState({})
const [experienceModal,setExperienceModal]=useState(false)

useEffect(()=>{
  setExperienceData(data)
  },[data])

const onEditExperience=(data)=>{
    setEditData(data)
    setExperienceModal(true) 
}


const onAddExperienceData=()=>{ 
    setEditData({})
     setExperienceModal(true) 
 }

 

  return (
    <>
      <div style={{marginTop:10,paddingLeft:20,marginBottom:50}} >

<div   style={{
    flex: 1,
    flexDirection: 'row',
    display: 'flex',
    width: '500px',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 5,
    ...(isEmpty(error) || !isEmpty(data)
      ? {}
      : {
          borderRadius: 10,
          border: '2px solid red',
          height: 50,
          padding: 20,
          right: 40,
        }),
  }}
>  <div style={{flex:1,flexDirection:'row',display:'flex',marginTop:10}}>
<h3 style={{ fontWeight:'600',
fontSize:'16px',color: '#373a40'}}>Experience</h3>
{asterikSign()}
</div>
<div onClick={onAddExperienceData} className="add_icon" style={{marginTop:0}}>
<AddCircleOutlineIcon fontSize="large" style={{marginTop:'3px',marginLeft:'45px'}} />
</div>       

   </div>
   {!isEmpty(error) && isEmpty(data)  && errorSec(error)}


<div className="r9-education__c1-education-div">
{
          experienceData && 
            experienceData?.map((experience, index) => {
              console.log({experienceData})
              return <ProfileCompletionExperienceDiv key={index} experience={experience}  onEdit={onEditExperience}/>;
            })
 
        }
</div> 

      </div>
      {experienceModal && (<ProfileCompletionExperienceModal editData={editData} dataList={experienceData} setData={setExperienceData}  isVisible={experienceModal} onClose={()=>{
       getUpdatedData() 
       setExperienceModal(false)
      } 
      }/>)}

    </>
  );
}

export default ProfileCompletionCandidateExperience;
